import React from "react";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const ChatsDefaultMessage = (props: { message: string }) => {
  return (
    <div className="welcome-default-message-content px-5 py-2 d-center">
      <div className="welcome-default-message-body ellipsis line-2 text-center font-gotham-bold color-black font-size-13_14">
        {UtilityHelper.linkifyText(props.message)}
        {/* {textCase(props.message)} */}
      </div>
    </div>
  );
};

export default ChatsDefaultMessage;
